var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","text":"","icon":"","small":"","ater":"","title":"Hide search panel"},on:{"click":function($event){$event.stopPropagation();_vm.hide_search = !_vm.hide_search}}},[_c('v-icon',[_vm._v(_vm._s(_vm.faIcon("left_arrow")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }